import { render, staticRenderFns } from "./PerfilSemAcesso.vue?vue&type=template&id=29c32e61&scoped=true"
import script from "./PerfilSemAcesso.vue?vue&type=script&lang=js"
export * from "./PerfilSemAcesso.vue?vue&type=script&lang=js"
import style0 from "./PerfilSemAcesso.vue?vue&type=style&index=0&id=29c32e61&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c32e61",
  null
  
)

export default component.exports